/**
 * DOM·수학 정적 헬퍼.
 * - 단일 경로(@/utils/DomHelpers)로만 import 해서 Mac/Windows 번들 중복 방지.
 * - DPRDomHelpers 로 export 해서 minify 시 'C' 등 단일 문자와 충돌 방지.
 */
function lerp(a: number, b: number, n: number): number {
    return a + (b - a) * n;
}

function qs<T extends Element = Element>(
    parent: Document | Element,
    selector: string,
): T | null {
    return parent.querySelector<T>(selector);
}

function qsAll<T extends Element = Element>(
    parent: Document | Element,
    selector: string,
): T[] {
    return Array.from(parent.querySelectorAll<T>(selector));
}

function hasHover(): boolean {
    return window.matchMedia("(hover:hover) and (pointer:fine)").matches;
}

const DPRDomHelpers = { lerp, qs, qsAll, hasHover };
export { DPRDomHelpers as DomHelpers };
